import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", { style: {"max-width":"5rem","max-height":"5rem"} }, [
    _createElementVNode("div", {
      id: "box",
      onclick: "lightOff(this)",
      style: {"scale":"0.15","position":"relative","top":"-13rem","left":"-15rem"}
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["bulb circle", {[_ctx.light.color]: true, enlighted: _ctx.light.isOn}])
      }, [
        _createElementVNode("div", { id: "shine" })
      ], 2 /* CLASS */),
      _createElementVNode("div", {
        class: _normalizeClass(["bulb trapezoid", {[_ctx.light.color]: true, enlighted: _ctx.light.isOn}])
      }, null, 2 /* CLASS */),
      _createElementVNode("div", { id: "bottom1" }),
      _createElementVNode("div", { id: "bottom2" }),
      _createElementVNode("div", { id: "bottom3" }),
      _createElementVNode("div", {
        class: _normalizeClass(["halfCircle bulb", {[_ctx.light.color]: true, enlighted: _ctx.light.isOn}])
      }, null, 2 /* CLASS */),
      _createElementVNode("div", {
        class: "drop",
        id: "left"
      }),
      _createElementVNode("div", {
        class: "drop",
        id: "right"
      }),
      _createElementVNode("div", { id: "wire" })
    ])
  ]))
}